import { Alert, Skeleton } from 'antd';
import styled, { keyframes } from 'styled-components';

// Keyframe animation for blinking dots
const blink = keyframes`
  0%, 80%, 100% {
    opacity: 0.2;
  }
  40% {
    opacity: 1;
  }
`;

// justify-content: flex-end;
export const AgentStatusWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`;

export const StatusTag = styled.div`
  display: flex;
  align-items: end;
  gap: 5px;
  color: #333;
  font-style: italic;
`;

export const TypingIndicatorWrapper = styled.div`
  display: flex;
  gap: 4px;
  font-size: 32px;
  font-weight: bold;
  line-height: 1;
`;

// Each dot
export const Dot = styled.span`
  animation: ${blink} 1.4s infinite;
  opacity: 0.2;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
`;

export const ActionWrapper = styled.div`
  margin-left: 5px;
`;

export const TokenUsageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
`;

export const UsageText = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-size: 12px;
`;

export const OverLimitMessage = styled.div`
  .ant-alert {
    border-radius: 6px;
  }
`;

export const TokenUsageSkeleton = styled(Skeleton)`
  width: 200px;

  h3 {
    margin: 0;
  }
`;

export const TokenAlert = styled(Alert)`
  border: 0;
  background-color: #0000000a;
  font-size: 12px;
`;

export const BannerContainer = styled.div`
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 20px;
  margin: 20px;
  box-shadow: 0 2px 4px rgb(0 0 0 / 10%);
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
  justify-content: flex-end;
`;
